import axios from 'axios';
import { Dispatch } from 'redux';

const api = axios.create({
 baseURL: 'https://stagingapi.xorostory.com',
  //  baseURL: 'http://localhost:3000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  },
}); 

const FileApi = axios.create({
baseURL: 'https://stagingapi.xorostory.com',
  //  baseURL: 'http://localhost:3000',
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  maxContentLength: 50 * 1024 * 1024,
});

const token = localStorage.getItem('token'); 
api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
FileApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export const loginCheck = async () => {
    const response = await api.get(`/api/admin/check`);
    return response.data;
};

export const logoutUser = async () => {
  const response = await api.get(`/api/admin/logout`);
  return response.data;
};

export const fetchUsers = async (page: Number = 1) => {
  const response = await api.get(`/api/admin/roles/${page}`);
  return response.data;
};

export const fetchProjectEmailStatus = async (code: String) => {
  const response = await api.get(`/api/admin/fetchProjectEmailStatus/${code}`);
  return response.data;
};

export const lastIDOfProject = async () => {
  const response = await api.get(`/api/admin/lastIDOfProject`);
  return response.data;
};

export const fetchUsersByAccount = async (account_id: Number) => {
  const response = await api.get(`/api/admin/usersByAccount/${account_id}`);
  return response.data;
};

export const fetchLogin = async (email: string, password: string) => {
    const response = await api.post('/api/admin/login', {
      "auth": {
        email,
        password,
      }
    });
    return response.data;
};

export const getSubscriptions1 = async () => {
  const response = await api.get(`/api/admin/getSubscriptions`);
  return response.data;
};

export const get3dRepo = async () => {
  const response = await api.get(`/api/admin/get3dRepo`);
  return response.data;
};

export const fetchAccounts = async () => {
  const response = await api.get(`/api/admin/fetchAccounts`);
  return response.data;
};

export const checkRoleUpdation = async (id: any) => {
  const response = await api.post('/api/admin/checkRoleUpdation', {
    "checkRoleUpdation": {
      id:Number(id),
    }
  });
  return response.data;
};

export const aiChatBot = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBot', formData);
  return response.data;
};

export const aiChatBotTVS = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotTVS', formData);
  return response.data;
};

export const aiChatBotTVS2 = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotTVS2', formData);
  return response.data;
};

export const aiChatBotTVS3 = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotTVS3', formData);
  return response.data;
};

export const aiChatBotTVS4 = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotTVS4', formData);
  return response.data;
}; 

export const aiChatBotSCH = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotSCH', formData);
  return response.data;
};

export const managerAIApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/traningAIApi', formData);
  return response.data;
};

export const pmmAIApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/pmmAIApi', formData);
  return response.data;
};

export const TWCAIApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/TWCAIApi', formData);
  return response.data;
};

export const callAIApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/callAIApi', formData);
  return response.data;
}; 

export const aiChatBotcall2chat = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotcall2chat', formData);
  return response.data;
}; 

export const aiChatBotMaui = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotMaui', formData);
  return response.data;
};

export const aiChatBotMaui2 = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotMaui2', formData);
  return response.data;
};

export const aiChatBotDrone = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotDrone', formData);
  return response.data;
};  

export const aiChatBotMauiLaptop = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotMauiLaptop', formData);
  return response.data;
};

export const aiChatBotMauiVoice = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotMauiVoice', formData);
  return response.data;
}; 

export const aiChatBotMauiMam = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/aiChatBotMauiMam', formData);
  return response.data;
};

export const PostCallMauiApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/postCallMaui', formData); 
  return response.data;
};

export const PptAIApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/PptAIApi', formData);
  return response.data;
}; 

export const get_product_ai_users = async () => {
    const response = await api.get(`/api/admin/get_product_ai_users`);
    return response.data;
};

export const get_product_ai_user_details = async (email:string) => {
    const response = await api.get(`/api/admin/get_product_ai_user_details/?email=${email}`);
    return response.data;
};

export const newDataUpload_productAi = async (formData:any) => {
  try {
    const response = await FileApi.post('/api/admin/newDataUpload_productAi', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
}; 

export const deleteUser = async (id: any) => {
  const response = await api.post('/api/admin/deleteUser', {
    "deleteUser": {
      id:Number(id),
    } 
  });
  return response.data;
};

export const fetchUSDZModel = async () => {
  const response = await api.post('/api/admin/models/usdz', {
    "s3_key": '3d-repository/models/hari.usdz'
  });
  return response.data;
};

export const proDup = async (code: string,newName: string,selectedAccount: string) => {
  const response = await api.post('/api/admin/proDup', {
    "code": code,
    "newName": newName,
    "selectedAccount": selectedAccount
  });
  return response.data;
};

export const deleteProjects = async (id: any) => {
  const response = await api.post('/api/admin/deleteProject', {
    "deleteProject": {
      id:Number(id),
    }
  });
  return response.data;
}; 

export const updateProjectTrailStatus1 = async (code: string,status: boolean,trailPeriod: number,trailUsername: string) => {
  const response = await api.post('/api/admin/updateProjectTrailStatus', {
    "updateProjectTrailStatus": {
      'code' : code,
      'status' : status,
      'trailPeriod':trailPeriod,
      'trailUsername':trailUsername
    }
  });
  return response.data;
};

export const updateRoleUpdation = async (id: any) => {
  const response = await api.post('/api/admin/updateRoleUpdation', {
    "updateRoleUpdation": {
      id:Number(id),
    }
  });
  return response.data;
};

export const signUp = async (organization: string, name: string, email: string, phone: string, password: string, confirmPassword: string, role: Number = 1) => {
  const response = await api.post('/api/admin/signup', {
    "signup": {
      "account_id": Number(organization),
      "contact_person": name,
      "email": email,
      "phone": phone,
      "is_active": false,
      "users_attributes": [{
        "name": name,
        "email": email,
        "phone": phone,
        "password": password,
        "password_confirmation": confirmPassword,
        "role_id": role,
        "is_active": true,
      }]
    }
  });
  return response;
};

export const resetPassword = async (email: any,password: string) => {
  const response = await api.post('/api/admin/resetPassword', {
    "resetPassword": {
      email,
      password
    }
  });
  return response.data;
};

export const updateMemberRole = async (obj:any) => {
  const response = await api.post(`/api/admin/updateMemberRole`, {
    'updatedUsers' : obj
  });
  return response;
};

export const submitAccountChangesApi = async (obj:any) => {
  const response = await api.post(`/api/admin/updateAccount`, {
    'updatedAccount' : obj
  });
  return response;
};

export const updateAccountStatusApi = async (id:Number,status:string) => {
  const response = await api.post(`/api/admin/updateAccountStatus`, {
    'updateAccountStatus': {'id' : id,
                          'status' : status}
  });
  return response;
};

export const sendOtpApi = async (email:string) => {
  const response = await api.post(`/api/admin/otpMail`, {
    'mailCred': {'to_email' : email}
  });
  return response;
};  

export const trainingSessionReport = async () => {
  const response = await api.post(`/api/admin/trainingSessionReport`, {
    'mailCred': {'to_email' : ""}
  });
  return response;
};  

export const deleteAllEvents = async (projectName:any,platform:string) => {
  const response = await api.post(`/api/admin/deleteAllEvents`, {
    "deleteAllEvents": {
      'projectName' : projectName,
      'platform' : platform
    }
  });
  return response;
};

export const deleteSingleEvent = async (projectName:any,customerEmail:any,platform:string) => {
  const response = await api.post(`/api/admin/deleteSingleEvent`, {
    "deleteSingleEvent": {
      'projectName' : projectName,
      'customerEmail' : customerEmail,
      'platform' : platform
    }
  });
  return response;
};

export const updateProjectStatus1 = async (status:any,projectCode:any) => {
  const response = await api.post(`/api/admin/updateProjectStatus`, {
    "updateProjectStatus": {
      'status' : status,
      'projectCode' : projectCode,
    }
  });
  return response;
};

export const userUpdate = async (roleId: Number, UserId: Number) => {
  const response = await api.post(`/api/admin/roles/${UserId}`, {
    "user": {
      "role_id": roleId,
    }
  });
  return response;
};

export const avironixTestApi = async (formData: FormData) => {
  const response = await FileApi.post('/api/admin/avironixTest', formData);
  return response.data;
}

export const fetchDashboardDatas = async (page: Number = 1) => {
  const response = await api.get(`/api/admin/dashboard/${page}`);
  return response.data;
};

export const fetchDashboardProductDatas = async (projuct: String = "", page: Number = 1 , platform:string) => {
    const response = await api.get(`/api/admin/dashboard_project?project=${projuct}&page=${page}&platform=${platform}`);
    return response;
};

export const fetchDashboardProductDatasByEmail = async (project:string,email:string) => {
  const response = await api.get(`/api/admin/dashboard_project_byEmail?project=${project}&email=${email}`);
  return response;
};

export const projectTableColumnFetch = async (input:any) => {
  try {
    const response = await api.post('/api/admin/projectColumnDetails', {
      "text": input
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const fullTableFetch = async (input:any) => {
  try {
    const response = await api.post('/api/admin/fullTableFetch', {
      "text": input
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const storiesTableColumnFetch = async (input:any) => {
  try {
    const response = await api.post('/api/admin/storyColumnDetails', {
      "text": input
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const featuresTableColumnFetch = async (input:any) => {
  try {
    const response = await api.post('/api/admin/featureColumnDetails', {
      "text": input
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const audioEnhancer = async (input:any) => {
  try {
    const response = await api.post('/api/admin/audio/enhancer', {
      "text": input
    }
  );
    
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const audioConvert = async (input:any) => {
  try {
    const response = await api.post('/api/admin/audio/converter', {
      "text": input
    }
    , { responseType: 'blob' }
  );
    
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const audioUpload = async (input:any,name:string,page:string,projectName:any) => {
  try {
      const response = await api.post('/api/admin/audio/uploadAudio', {
        "text": input,
        "name": name,
        "page": page,
        "projectName": projectName
      });
      return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const convoaiAPI = async (input:any) => {
  try {
      const response = await api.post('/api/admin/kbr', {
        "text": input,
      // }, {
      //   responseType: 'blob' 
      });
      return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const fileUpload = async (input:any,page:string,projectName:any) => {
  try {
    input.append('page', page);
    input.append('projectName', projectName.replace(/\s+/g, ''))
    const response = await FileApi.post('/api/admin/file/fileUpload', input);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
}; 

export const customGPTFileUpload = async (formData:any) => {
  try {
    const response = await FileApi.post('/api/admin/customGTP/DataEssense', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
}; 

export const repoModelUpload = async (input:any) => {
  try {
    const response = await FileApi.post('/api/admin/file/repoModelUpload', input);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const repoImageUpload = async (input:any) => {
  try {
    const response = await FileApi.post('/api/admin/file/repoImageUpload', input);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const questionAudioUpload = async (input:any) => {
  try{
    const response = await FileApi.post('/api/admin/questionAudioUpload', input);
    return response;
  } catch (error) {
    console.error('Error create data',error)
  }
}

export const assestUpload = async (input:any,type:string,projectName:string) => {
  try {
    input.append('type', type);
    input.append('projectName', projectName.replace(/\s+/g, ''))
    const response = await FileApi.post('/api/admin/assestUpload', input);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const createAccount1 = async (name:string,contact_person:string,email:string,phone:any,subscription:number,accountAmount:any) => {
  try {
    const response = await api.post('/api/admin/createAccount', {
      "name": name,
      "contact_person": contact_person,
      "email": email,
      "phone": phone,
      "subscription": subscription,
      "amount": accountAmount
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const createProject = async (inputs:any,batchRunner:boolean,edit:boolean,code:any,questions:any) => {
  try {
    const response = await api.post('/api/admin/configurator/projects', {
      "project": inputs,
      "batchRunner": batchRunner,
      "edit": edit,
      "code": code,
      "questions":questions
    });
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const createStroies = async (inputs:any, code:any) => {
  try {
    const response = await api.post(`/api/admin/configurator/stories/${code}`, {
      "stories": inputs
    });
    
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const createFeatures = async (inputs:any, code:any) => {
  try {
    const response = await api.post(`/api/admin/configurator/features/${code}`, {
      "features": inputs
    });
    
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const createObjects = async (inputs:any, code:any) => {
  try {
    const response = await api.post(`/api/admin/configurator/objects/${code}`, {
      "objects": inputs
    });
    
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const fetchConfiguratorProjectsDatas = async (page: Number = 1) => {
  
  const response = await api.get(`/api/admin/configurator/projects/${page}`);
  return response.data;
};

export const fetchConfiguratorProjectData = async (code: String) => {
  const response = await api.get(`/api/admin/configurator/project/${code}`);
  return response;
};

export const fetchConfiguratorStoryData = async (code: String) => {
  const response = await api.get(`/api/admin/configurator/stories/${code}`);
  return response;
};

export const deleteStoryData = async (code: any,id: any) => {
  const response = await api.get(`/api/admin/configurator/stories/delete/${code}/${id}`);
  return response;
};

export const fetchConfiguratorFeaturesData = async (code: string) => {
  const response = await api.get(`/api/admin/configurator/features/${code}`);
  return response;
}

export const deleteFeaturesData = async (code: any,id: any) => {
  const response = await api.get(`/api/admin/configurator/features/delete/${code}/${id}`);
  return response;
};

export const fetchConfiguratorObjectssData = async (code: string) => {
  const response = await api.get(`/api/admin/configurator/objects/${code}`);
  return response;
}

export const deleteConfiguratorProjectCustomField = async (id: any) => {
  const response = await api.delete(`/api/admin/configurator/project/custom_field/${id}`);
  return response;
}

export const deleteConfiguratorStoryCustomField = async (id: any) => {
  const response = await api.delete(`/api/admin/configurator/story/custom_field/${id}`);
  return response;
}

export const deleteConfiguratorFeatureCustomField = async (id: any) => {
  const response = await api.delete(`/api/admin/configurator/feature/custom_field/${id}`);
  return response;
}

export const deleteConfiguratorObjectCustomField = async (id: any) => {
  const response = await api.delete(`/api/admin/configurator/object/custom_field/${id}`);
  return response;
}

export const fetchOptionsAccount = async () => {
  const response = await api.get('/api/admin/configurator/options/accounts');
  return response;
}


// oli

export const oli_products_get = async () => {
  const response = await api.get(`/api/admin/oli/products/get`);
  return response.data;
};

export const oli_product_users_get_with_project_data = async (project_id: number) => {
  const response = await api.get(`/api/admin/oli/product/users/get?project_id=${project_id}`);
  return response.data;
};

export const oli_project_newUser = async (formData:any) => {
  try {
    const response = await FileApi.post('/api/admin/oli/project/newUser', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
}; 

export const get_oli_user_call_details = async (id: string,project_id: string) => {
  const response = await api.get(`/api/admin/oli/user/call/details/${id}/${project_id}`);
  return response.data;
};

export const oli_new_call_transcription = async (formData: FormData) => {
  try {
    const response = await FileApi.post('/api/admin/oli/user/call/transcription', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const fetchOliLogin = async (email: string, password: string) => {
    const response = await api.post('/api/admin/oli/login', {
      "auth": {
        email,
        password,
      }
    });
    return response.data;
};

export const OliLogoutUser = async () => {  
  const response = await api.get(`/api/admin/oli/logout`);
  return response.data;
};

export const oli_create_update_project = async (formData: FormData) => {
  try {
    const response = await FileApi.post('/api/admin/oli/create/update/project', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};


// oli staging

export const oli_staging_products_get = async () => {
  const response = await api.get(`/api/admin/oli_staging/products/get`);
  return response.data;
};

export const oli_staging_product_users_get_with_project_data = async (project_id: number) => {
  const response = await api.get(`/api/admin/oli_staging/product/users/get?project_id=${project_id}`);
  return response.data;
};

export const oli_staging_project_newUser = async (formData:any) => {
  try {
    const response = await FileApi.post('/api/admin/oli_staging/project/newUser', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
}; 

export const oli_staging_user_call_details = async (id: string,project_id: string) => {
  const response = await api.get(`/api/admin/oli_staging/user/call/details/${id}/${project_id}`);
  return response.data;
};

export const oli_staging_new_call_transcription = async (formData: FormData) => {
  try {
    const response = await FileApi.post('/api/admin/oli_staging/user/call/transcription', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

export const fetchOli_stagingLogin = async (email: string, password: string) => {
    const response = await api.post('/api/admin/oli_staging/login', {
      "auth": {
        email,
        password,
      }
    });
    return response.data;
};

export const oli_stagingLogoutUser = async () => {  
  const response = await api.get(`/api/admin/oli_staging/logout`);
  return response.data;
};

export const oli_staging_create_update_project = async (formData: FormData) => {
  try {
    const response = await FileApi.post('/api/admin/oli_staging/create/update/project', formData);
    return response;
  } catch (error) {
    console.error('Error create data', error);
    throw error;
  }
};

// Maui

export const checkMauiAdmin = async (id:number) => {
  const response = await api.post(`/api/admin/checkMauiAdmin`, {
    'id': id
  });
  return response;
}; 

export const checkMauiUser = async (id:number) => {
  const response = await api.post(`/api/admin/checkMauiUser`, {
    'id': id
  });
  return response;
}; 

export const mauiUserCreation = async (account_id:number,username:string,mobile_no:string,interested_part:string) => {
  const response = await api.post(`/api/admin/mauiUserCreation`, {
    account_id,
    username,
    mobile_no,
    interested_part
  });
  return response;
}; 

export const mauiUserUrlUpdation = async (id:number,url:string) => {
  const response = await api.post(`/api/admin/mauiUserUrlUpdation`, {
    "id": id,
    'url': url
  });
  return response;
};

export const mauiUserLike = async (id:number) => {
  const response = await api.post(`/api/admin/mauiUserLike`, {
    'id': id
  });
  return response;
}; 

export const sessionStart = async (user_id:number) => {
  const response = await api.post(`/api/admin/mauiSessionStart`, {
    'user_id': user_id
  });
  return response;
}; 

export const sessionEnd = async (user_id:number,time_cal:string) => {
  const response = await api.post(`/api/admin/mauiSessionEnd`, {
    'user_id': user_id,
    "time_cal": time_cal
  });
  return response;
}; 

export const getThread = async (user_id:number) => {
  const response = await api.post(`/api/admin/getThread`, {
    'user_id': user_id,
  });
  return response;
}; 

export const getMauiDashboardData = async () => {
  const response = await api.get(`/api/admin/getMauiDashboardData`)
  return response;
}; 
